module.exports = __webpack_public_path__ + "static/media/bearingImage7.45ab8bc6.jpg";